// src/Public/landing-data.js
import { ASSETS } from './assets-data.js';

const LandingData = {
    en: {
        seo: {
            title: 'Cape Coral Boat Lift Repair & Installation | Tropical Marine Construction',
            description: 'Tropical Marine Construction in Cape Coral — experts in dock construction, boat lift installation, repair and maintenance. 30+ years. License #CBC1260600. Call (239) 542-1004.',
            keywords: 'Cape Coral boat lift, dock construction Cape Coral, boat lift repair SWFL, marine contractor Lee County, Tropical Marine Construction'
        },

        heroSection: {
            heroMedia: ASSETS.BOATLIFTS_1 || '',
            heroTitle: 'PROFESSIONAL DOCK CONSTRUCTION & BOAT LIFT INSTALLATION.',
            heroTagline: 'CAPE CORAL\'S PREFERRED MARINE CONTRACTOR',
            heroSubtitle: '',
            heroDescription: 'Honest, dependable marine construction services for waterfront property owners throughout Southwest Florida. Dock construction, boat lift sales and installation, repair, maintenance, and tiki huts — done right.',
            heroSubDescription: '30+ Years of Experience | License #CBC1260600',
            primaryCtaText: 'GET A FREE ESTIMATE',
            secondaryCtaText: 'VIEW OUR SERVICES',
        },

        trustSection: {
            media: ASSETS.BADGE_LOGO || '',
            title: 'CAPE CORAL\'S PREFERRED MARINE CONTRACTOR',
            subtitle: 'TRUSTED FOR OVER 30 YEARS',
            description: 'Tropical Marine Construction has professionally assisted our customers in building lifestyles for enhanced waterfront living. Our business has become the preferred marine building contractor in Cape Coral and Lee County. A quick scroll through our photographed projects illustrates why we\'ve earned the reputation as the marine contractors who consistently meet and exceed customer expectations.',
            footerNote: 'We stand behind our work with written guarantees, manufacturer warranties, approved design drawings, issued permits, and proposals for every project.',
            points: [
                {
                    title: 'Fully Licensed & Insured',
                    description: 'Florida Certified Building Contractor License #CBC1260600. No work begins until all permits are secured.'
                },
                {
                    title: 'Custom Design & Build',
                    description: 'We design and build to fit your waterfront, your vision, and your budget — not ours.'
                },
                {
                    title: 'Written Guarantees',
                    description: 'Every project includes written guarantees, manufacturer warranties, and a signed proposal before work begins.'
                }
            ],
            ctaText: 'CONTACT US TODAY'
        },

        infoCardsSection: {
            title: 'Our Marine Construction Services',
            subtitle: 'Everything Your Waterfront Needs.',
            description: 'From new dock construction to boat lift installation, maintenance, repair, and custom tiki huts — we handle every aspect of waterfront construction in SWFL.',
        },

        contentSection: {
            label: 'Our Mission',
            title: 'Tropical Marine Construction Will Help You Maintain Your Waterfront Lifestyle in SWFL',
            subtitle: 'Continuously striving to achieve perfection with every boat lift installation and repair.',
            backgroundImage: ASSETS.DOCKS_1 || '',
            buttonText: 'Learn About Us →',
        },

        metricsSection: {
            metrics: [
                { value: 30,  suffix: '+', label: 'Years of Experience',        duration: 3 },
                { value: 100, suffix: '%', label: 'Permitted & Inspected',       duration: 3.2 },
                { value: 20,  suffix: 'K', label: 'Max Lift Capacity (lbs)',     duration: 3.5 },
                { value: 100, suffix: '%', label: 'Customer Satisfaction',       duration: 2.8 },
            ],
            disclaimer: '* Florida Certified Building Contractor License #CBC1260600. Serving Cape Coral, Lee County & Collier County.'
        },

        specialsBannerSection: {
            title: 'READY TO START YOUR PROJECT?',
            highlight: 'CALL US TODAY.',
            subtitle: 'Free estimates for all dock and boat lift projects in Cape Coral and Lee County.',
            ctaText: 'GET A FREE ESTIMATE',
            images: [
                ASSETS.BOATLIFTS_PROMO || '',
                ASSETS.DOCKS_2_JPG || '',
            ],
            mobileImages: [
                ASSETS.BOATLIFTS_1 || '',
                ASSETS.DOCKS_1 || '',
            ]
        },

        shopHeroSection: {
            image: ASSETS.BOATLIFTS_1 || '',
            titleLine1: 'Built For',
            titleHighlight: 'Waterfront Living.',
            titleLine2: 'Done Right.',
            subtitle: 'Custom dock construction & boat lift installation.\nCape Coral\'s trusted marine contractor.',
            ctaText: 'VIEW OUR SERVICES',
            trustText: 'Trusted by Cape Coral & Lee County waterfront owners for 30+ years.',
            categoryShopPrefix: 'EXPLORE',
        },

        categoriesBentoSection: {
            title: 'OUR SERVICES',
            subtitle: 'Everything your waterfront needs.',
            maxCategories: 4,
        },

        imageGridSection: {
            items: [
                {
                    image: ASSETS.DOCKS_1 || '',
                    title: 'Dock Construction',
                    description: 'Custom stationary docks, floating docks, kayak docks, and wrap-around docks built for SWFL waterfront properties.',
                    bgColor: 'bg-primary-900',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-60 group-hover:opacity-100 transition-opacity',
                    link: '/services/dock-construction'
                },
                {
                    image: ASSETS.BOATLIFTS_1 || '',
                    title: 'Boat Lift Installation',
                    description: 'New and used FMS boat lifts for all watercraft — PWC, pontoon, hydraulic, and solar lift systems.',
                    bgColor: 'bg-secondary-700',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-70 group-hover:scale-110 transition-transform duration-700',
                    link: '/services/boat-lift-installation'
                },
                {
                    image: ASSETS.BOATLIFTS_3 || '',
                    title: 'Boat Lift Repair',
                    description: 'Motor, cable, pulley, and bunk replacement. Fast response for all makes and sizes throughout Lee County.',
                    bgColor: 'bg-primary-500',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-80',
                    link: '/services/boat-lift-repair'
                },
                {
                    image: ASSETS.IMAGE_7 || '',
                    title: 'Tiki Huts',
                    description: 'Custom tiki huts, chickee huts, and tiki umbrellas — commercial-grade, hurricane-rated, and built for SWFL.',
                    bgColor: 'bg-slate-100',
                    textColor: 'text-primary-950',
                    imgPositionClass: 'inset-0 object-cover opacity-40 mix-blend-multiply',
                    link: '/services/tiki-huts'
                }
            ]
        }
    }
};

export function getLandingData(language) {
    return LandingData[language] || LandingData.en;
}

export default LandingData;
